import axios from "axios";
import { Message } from "element-ui";
const user = {
  state: () => ({
    token: localStorage.getItem("token"),
    language: "tr",
    user: null
  }),
  mutations: {
    setToken(state, payload) {
      state.token = payload;
      axios.defaults.headers["Authorization"] = "Bearer " + payload;
      localStorage.setItem("token", payload);
    },
    /* setLanguage(state, language) {
              state.language = language;
              axios.defaults.headers["language"] = payload;
              localStorage.setItem("lang", language);
            }, */
    setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    async userUpdate(store, payload) {
      var res = await axios.post("account/update", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        store.dispatch("getUser");
      }
      return res;
    },
    async userPasswordUpdate(store,payload) {
      var res = await axios.post("account/changepassword", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        store.dispatch("getUser");
      }
      return res;
    },
    async getUser(store) {
      var res = await axios.post("account/get").then(res => {
        store.commit("setUser", res.data.data);
        return res;
      });
      return res.data;
    },
    async updatePrinterID(store, payload) {
      axios
        .post("account/updateprinterid", {
          printerID: store.state.user.user.printerID
        })
        .then(res => {
          if (res.data.alert.hasError) {
            Message.error(res.data.alert.message);
          } else {
            Message.success(res.data.alert.message);
          }
        });
    }
  },
  getters: {
    currentUser(state) {
      if (state.user == null) {
        return {};
      }
      return state.user.user;
    }

    /* getLanguage: (state) => state.language */
  }
};
export default user;



// WEBPACK FOOTER //
// ./src/store/user.js